import { useEffect, useState } from 'react'

import styled from 'styled-components'
import { Image } from 'shared/ui'
import { useAppSelector } from 'shared/config/store'
import { SearchNode } from 'shared/api/searchApi'
import { getSmallPreviewLink } from 'shared/utils/filesUtils'
import { assetsApi } from 'shared/api/assetsApi'

// Function to get file icon based on file type
const getFileIcon = () => {
  return '/images/asset.svg'
}

interface DuplicatePreviewProps {
  duplicate: SearchNode
}

// Component to display duplicate file preview or icon
export const DuplicatePreview = ({ duplicate }: DuplicatePreviewProps) => {
  const [previewUrl, setPreviewUrl] = useState<string>('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const userId = useAppSelector(state => state.user?.user?.family_user_id)

  useEffect(() => {
    // If the duplicate already has preview info (unlikely for SearchNode but possible)
    if ((duplicate as any)?._embedded?.previews) {
      const url = getSmallPreviewLink(duplicate as any)
      if (url) {
        setPreviewUrl(url)
        return
      }
    }

    // Only try to load preview for image files to avoid unnecessary requests
    if (duplicate.file_info?.type === 'image' && userId && !loading && !previewUrl && !error) {
      setLoading(true)
      
      assetsApi.getAssetInfo(userId, duplicate.id, undefined, { preview: true, preview_jwt: true })
        .then(assetWithPreview => {
          const url = getSmallPreviewLink(assetWithPreview)
          if (url) {
            setPreviewUrl(url)
          } else {
            setError(true)
          }
        })
        .catch(() => {
          setError(true)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [duplicate.id, duplicate.file_info?.type, userId, loading, previewUrl, error])

  // Determine what to show
  let src = getFileIcon()
  if (previewUrl) {
    src = previewUrl
  }

  return (
    <SPreviewContainer>
      <Image
        src={src}
        alt={duplicate.name}
        width={48}
        height={48}
        style={{ 
          borderRadius: 4, 
          objectFit: 'cover',
          backgroundColor: '#f5f5f5',
          opacity: loading ? 0.7 : 1
        }}
        preview={false}
        fallback={getFileIcon()}
      />
    </SPreviewContainer>
  )
}

const SPreviewContainer = styled.div`
  margin-left: auto;
  flex-shrink: 0;
`